import { createTheme, type Theme } from '@shared/components';

import './augmentation';

const theme = createTheme({
  components: {
    Sidebar: {
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, ...theme } }: { theme: Theme }) =>
          sx({
            '& > .MuiPaper-root': {
              height: '100%',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            },
            '.MuiList-root': {
              display: 'flex',
              flexDirection: 'column',
              p: theme.spacing(4),
            },
            '.MuiList-dense': {
              '.MuiListItemButton-root': {
                m: 0,
              },
            },
            '.MuiListItemButton-root': {
              display: 'flex',
              width: 1,
              mb: theme.spacing(1),
              p: theme.spacing(2.5, 3),
              borderRadius: theme.shape.rounded(2),
              a: { display: 'inherit', alignItems: 'center' },
              color: theme.palette.text.secondary,

              '.MuiListItemIcon-root': {
                minWidth: 0,
                width: 24,
                mr: 2,
                alignItems: 'center',
                justifyContent: 'center',
                color: 'inherit',

                '.MuiSvgIcon-root': {
                  fontSize: '1.5rem',
                },
              },
              '.MuiTypography-root': {
                fontSize: theme.typography.body2.fontSize,
                wordBreak: 'break-all',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              },

              '&.Mui-selected': {
                color: theme.palette.primary.darker,
                '.MuiListItemIcon-root': {
                  color: 'inherit',
                },
                '.MuiTypography-root': {
                  textDecoration: 'none',
                  fontWeight: 600,
                },
              },

              '&.Mui-disabled': {
                color: theme.palette.text.disabled,
                opacity: 1,
              },
            },

            '.MuiListItemButton-root.section': {
              '.MuiTypography-root': {
                fontSize: theme.typography.body2.fontSize,
              },
            },

            '.MuiAccordion-root.MuiPaper-root': {
              p: 0,
              width: 1,
              minWidth: 0,
              boxSizing: 'border-box',
              '&::before, &::after': {
                display: 'none',
              },
              '.MuiAccordionSummary-root': {
                minWidth: 0,
                p: 0,
                m: 0,
                '.MuiAccordionSummary-content': {
                  minWidth: 0,
                  m: 0,
                },
                '.MuiAccordionSummary-expandIconWrapper': {
                  position: 'absolute',
                  right: 8,
                  top: 8,
                },

                '.MuiAccordionSummary-content:has(.Mui-selected) ~ .MuiAccordionSummary-expandIconWrapper':
                  {
                    color: theme.palette.primary.darker,
                  },
              },
              '.MuiAccordionDetails-root': {
                p: 0,

                // submenu
                '.MuiListItemButton-root': {
                  '.MuiSvgIcon-root': {
                    fontSize: 5,
                  },

                  '&.Mui-selected': {
                    bgcolor: 'inherit',

                    '.MuiSvgIcon-root': {
                      fontSize: 10,
                    },
                    '.MuiTypography-root': {
                      color: theme.palette.text.primary,
                    },
                  },
                },
              },
            },

            '.MuiButton-root.toggle-sidebar': {
              minWidth: 'fit-content',
              mt: 'auto',
              borderRadius: 100,
              borderColor: theme.palette.grey[300],
              color: theme.palette.text.secondary,
              '.MuiButton-startIcon': {
                mr: 0,
              },
              '.MuiSvgIcon-root': {
                fontSize: '1.5rem',
              },
              '.MuiTypography-root': {
                flexShrink: 0,
                fontWeight: 600,
              },
            },

            // secondary sidebar
            '&.secondary': {
              '.MuiBox-root.header': {
                p: 2,
                gap: 2,
                alignItems: 'center',
                '.MuiButton-root': {
                  minWidth: 0,
                },
              },

              '.MuiTypography-root.submenu-title': {
                px: 2,
                py: 0.5,
              },
            },
          }),
      },
    },
  },
});

export default theme.components;
